import { useQuery } from '@apollo/client';
import { useCallback, useRef } from 'react';
import { useHistory } from 'react-router';

import GoalTemplateForm from '@components/forms/GoalTemplateForm';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useMyExpert from '@hooks/useMyExpert';
import { GetGoalTemplateDocument, GetGoalTemplateQuery, GetGoalTemplateQueryVariables } from '@typing/Generated';
import { journeyRoute } from '@utils/routeUtils';

type Props = {
  goalTemplateId: string;
  journeyId: string;
};

const ExpertJourneyGoalTemplateEditPage = ({ goalTemplateId, journeyId }: Props) => {
  const history = useHistory();
  const myExpert = useMyExpert();
  const contentRef = useRef<HTMLIonContentElement>(null);

  const getGoalTemplateQuery = useQuery<GetGoalTemplateQuery, GetGoalTemplateQueryVariables>(GetGoalTemplateDocument, {
    variables: { id: goalTemplateId }
  });

  const handleFormCancelOrSuccess = () =>
    history.push(journeyRoute({ journeyId, linkAfterJourney: '/goal-templates/table', myExpert }));

  const handleFormError = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollToTop(2000);
    }
  }, [contentRef]);

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.goalTemplate.edit" journeyId={journeyId}>
      <HandleQuery query={getGoalTemplateQuery}>
        {data => (
          <GoalTemplateForm
            autofocus
            goalTemplate={data.goalTemplate}
            onCancel={handleFormCancelOrSuccess}
            onError={handleFormError}
            onSuccess={handleFormCancelOrSuccess}
          />
        )}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyGoalTemplateEditPage;
